import { Spinner } from "react-bootstrap";
import { entityConfig } from "../../util/entityConfig";
import ListPageCardComponent from "../../components/ListPageCardComponent";
import { ExportFunctions } from "../../util/ExportFunctions";
import { RequestParamsModel } from "../../models/requestParams.model";
import { FaFileExcel, FaRegFileExcel } from "react-icons/fa";

interface ProcessListTableProps {
    isLoading: boolean;
    guidQuery: string;
    onHasRowsChange?: (hasRows: boolean) => void;
}

export const ProcessListTable = ({ isLoading, guidQuery, onHasRowsChange }: ProcessListTableProps) => {
	const entity = entityConfig.PROCESS;

	return (
		<>
			{isLoading && <><Spinner />🔍 Processando a busca, aguarde...</>}
			{!isLoading && guidQuery &&
                <ListPageCardComponent
					idDataset={'MOVIMENTOS'}
					serviceController={entity.controller}
					legend={entity.listTitle}
					selectedItem={undefined}
					setSelectedItem={() => { }}
					buttons={[{
						onClick: async () => {
							await ExportFunctions.downloadExcelWithEndpoint(
								entity.controller,
								RequestParamsModel('MOVIMENTOS'),
							`GetProcesses/${guidQuery}/ExportExcel`,
								'MOVIMENTOS',
								'processos'
							);
						},
						text: "Exportar",
						disabled: false,
						icon: (<>
							<FaRegFileExcel className="fa-icon" />
							<FaFileExcel className="fa-icon-hover" />
						</>),
						tooltip: "Exportar dados para Excel",
					}]} 
					referenceColumn={entity.itemKey}
					showModal={false}
					setShowModal={() => {

					}}
					delParams={undefined}
					endpointPath={`GetProcesses/${guidQuery}`}
                    showBreadcrumb={false}
                    watchFilters={false}
                    onStatsChange={(stats: any) => {
                        if (onHasRowsChange) {
                            const canExport = Boolean(stats?.hasAnyItems && stats?.hasProcessNumber);
                            onHasRowsChange(canExport);
                        }
                    }}
				/>
			}
		</>
	);
};
